import { combineReducers } from '@reduxjs/toolkit'
import products from '../features/products/productSlice'
import store from '../features/store/storeSlice'
import analytics from '../features/analytics/analyticsSlice'
import style from '../features/style/styleSlice'
import expire from '../features/expiration/expirationSlice'
import name from '../features/experienceName/experienceNameSlice'
import createdBy from '../features/experienceCreatedBy/experienceCreatedBySlice'
import qrCode from '../features/qrCode/qrCodeSlice'
import listing from '../features/listing/listingSlice'
import linksHeader from '../features/links/linkHeaderSlice'
import links from '../features/links/linkSlice'
import user from '../features/user/userSlice'
import vmmvModes from '../features/visualizationModes/visualizationModesSlice'
import brands from '../features/brands/brandsSlice'
import expType from '../features/experienceType/experienceTypeSlice'

import storeList from '../features/store/storeListSlice'

const vmData = combineReducers({
  expType,
  products,
  store,
  analytics,
  style,
  expire,
  linksHeader,
  links,
  name,
  createdBy,
  vmmvModes,
})

const rootReducer = combineReducers({
  vmData,
  qrCode,
  listing,
  user,
  brands,
  storeList,
})

export type RootState = ReturnType<typeof rootReducer>
export default rootReducer
